/**
 * Created by OBL on 14/01/2016.
 */
define('superAdminMbAnasController',[
    'module',
    'underscore',
    'app',
    'superAdminMbAnasView',
    'bootbox',
    'mbAnaCreateEditLayoutView',
    'settings',
    'entities/mbanas'
], function(
    module,
    _,
    App,
    View,
    bootbox,
    CreateEditLayoutView
    ) {
    'use strict';

    var SuperAdminMbAnaListController = {
        showMbAnaList: function(data) {
            var view = new View({data: data});
            this.view = view;
            view.listenTo(view, 'onGridLoaded', _.bind(this.onGridLoaded, this));
            view.listenTo(view, 'mbana:delete', _.bind(this.onDelete, this));
            App.regions.getRegion('main').currentView.getRegion('content').show(view);
        },

        showMbAnaAdd: function() {
            this.createEditView = new CreateEditLayoutView({
                mbanaModel: App.request('mbana:model'),
                newItem: true
            });
            this.createEditView.show({
                title: _.i18n('mbana.new')
            });
        },

        onGridLoaded: function() {
            var data = {
                url: App.request('mbana:get-collection-url'),
                rowCountUrl: App.request('mbana:get-count-url')
            };

            this.view.displayGrid(data);
        },

        onDelete: function(secId){
            bootbox.confirm(_.i18n('mbana.confirmDelete'), _.bind(function(result) {
                if(result){
                    App.request('mbana:delete', secId)
                        .done(_.bind(function(){
                            this.view.updatePagination('reloadGrid');
                        }, this));
                }
            }, this));
        }
    };

    module.exports = SuperAdminMbAnaListController;
});
